/* eslint-disable import/prefer-default-export */
import { computed, unref, type Ref } from 'vue';
import type { WbFile } from '@/entities/Entities';
import { useBlob } from '@/hooks/file';
import type { FileUpload } from './fileUpload';
import { thumbnailUrl } from '@/utils/api';

interface ThumbnailSize {
  width: number;
  height: number;
}
interface Options {
  thumbnail?: boolean | Ref<boolean>;
  thumbnailSize?: ThumbnailSize | Ref<ThumbnailSize>;
}

export function useWbFile(
  file?: FileUpload<WbFile> | Ref<FileUpload<WbFile> | undefined>,
  options?: Options,
) {
  const { blob: wbFile, loading } = useBlob(
    computed(() => {
      const actualFile = unref(file);
      if (!actualFile) return undefined;
      if (actualFile.isNew) return undefined;
      if (unref(options?.thumbnail)) { return thumbnailUrl(actualFile.file, unref(options?.thumbnailSize)); }
      return actualFile.file?.contentUrl;
    }),
  );

  const newFile = computed(() => {
    const actualFile = unref(file);
    if (actualFile?.isNew) return actualFile;
    return undefined;
  });

  const discriminatedFile = computed(() => wbFile.value ?? newFile.value?.file);

  return {
    file: discriminatedFile,
    newFile,
    existingFile: wbFile,
    loading,
  };
}
